var cosmosConfig = {}

cosmosConfig.endpoint = 'https://qa-bc-subsidy-cosmos-db.documents.azure.com:443/'
cosmosConfig.key = 'n61cdZr7J6twdMAJopb5XLUaU2QtIA31HIpdnDO0xJ3F8jupF7Dbob2XB3RsHEXTybhlJtgLLA4vACDbL9eZeQ=='

cosmosConfig.database = {
  id: 'qa-bc-db'
}

cosmosConfig.casesContainer = {
  id: 'cases'
}

cosmosConfig.bcContainer = {
  id: 'bargainingCouncils'
}

cosmosConfig.invoiceContainer = {
  id: 'invoices'
}

cosmosConfig.subsidyRatesContainer = {
  id: 'subsidyRates'
}

cosmosConfig.auditLogsContainer = {
  id: 'auditTrail'
}

cosmosConfig.rolesContainer = {
  id: 'roles'
}

module.exports = cosmosConfig